import { createSlice } from '@reduxjs/toolkit';
import { get } from 'lodash-es';
import { createAsyncAction } from '../action/index';

const getFaqs = createAsyncAction('getFaqs', 'getFaqs');
const getEnabledFeatures = createAsyncAction('getEnabledFeatures', 'getEnabledFeatures');
const getEnabledFeaturesForAll = createAsyncAction('getEnabledFeaturesForAll', 'getEnabledFeaturesForAll');

interface InitialState {
  feature: {
    diagnosticsPresent: boolean;
    medicinePresent: boolean;
    hideBannerForPatient: boolean;
    visitID: string;
  },
  featureForAll: {
    diagnosticOrdering: boolean;
    medicineOrdering: boolean;
  },
  faqs: [],
  isFetchingFaqs: boolean,
  isFetchingEnabledFeatures: boolean,
  isFetchingEnabledFeaturesForAll: boolean,
  isGoogleMapScriptLoad: boolean,
  isWebView: boolean,
}

const initialState = {
  feature: {},
  featureForAll: {},
  faqs: [],
  isFetchingFaqs: false,
  isFetchingEnabledFeatures: false,
  isFetchingEnabledFeaturesForAll: false,
  isGoogleMapScriptLoad: false,
  isWebView: false,
} as InitialState;

export const counterSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    updateAppState: (state, action) => Object.assign(state, action.payload),
  },
  extraReducers: {
    [getFaqs.pending as any]: (state) => {
      state.isFetchingFaqs = true;
    },
    [getFaqs.fulfilled as any]: (state, { payload }) => {
      state.faqs = payload || [];
      state.isFetchingFaqs = false;
    },
    [getFaqs.rejected as any]: (state) => {
      state.isFetchingFaqs = false;
    },
    [getEnabledFeatures.pending as any]: (state) => {
      state.isFetchingEnabledFeatures = true;
    },
    [getEnabledFeatures.fulfilled as any]: (state, { payload }) => {
      state.feature = get(payload, 'visitInfo[0]', {});
      state.isFetchingEnabledFeatures = false;
    },
    [getEnabledFeatures.rejected as any]: (state) => {
      state.isFetchingEnabledFeatures = false;
    },
    [getEnabledFeaturesForAll.pending as any]: (state) => {
      state.isFetchingEnabledFeaturesForAll = true;
    },
    [getEnabledFeaturesForAll.fulfilled as any]: (state, { payload }) => {
      state.featureForAll = payload;
      state.isFetchingEnabledFeaturesForAll = false;
    },
    [getEnabledFeaturesForAll.rejected as any]: (state) => {
      state.isFetchingEnabledFeaturesForAll = false;
    },
  },
});

// Action creators are generated for each case reducer function
// export const { increment, decrement, incrementByAmount, } = counterSlice.actions
const { updateAppState } = counterSlice.actions;
export {
  updateAppState,
  getFaqs,
  getEnabledFeatures,
  getEnabledFeaturesForAll,
};
export default counterSlice.reducer;